import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SwitchService {

  constructor() { }

  switchEnable(isEnabled: boolean){
    if(isEnabled === true){
      isEnabled = false;
    }else{
      isEnabled = true;
    }
  }

}
